import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'

export default class LandingPageApi {
    getConfig() {
        const token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''

        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    getHomeData() {
        return axios.get(`${URL_API}/landing-page/home`)
    }
}



// WEBPACK FOOTER //
// ./src/api/landing-page-api/LandingPageApi.js